// import React, { useState, useEffect } from 'react';
// import Modal from 'react-modal';

// const WorkflowMeasurementModal = ({ isOpen, onRequestClose, onSelect, hostId, brandId, modelId }) => {
//   const [dropdownData, setDropdownData] = useState([]);
//   const [selectedMetric, setSelectedMetric] = useState(null);

//   useEffect(() => {
//     if (isOpen && hostId) {
//       console.log("Measurement Modal abierto. Iniciando fetch de métricas...");
//       fetchMetrics();
//     }
//   }, [isOpen, hostId]);

//   const fetchMetrics = async () => {
//     try {
//       const response = await fetch(`http://127.0.0.1:8000/api/metrics?hostId=${hostId}&brandId=${brandId}&modelId=${modelId}`);
//       const data = await response.json();
//       const formattedData = data.map((metric) => ({
//         id: metric.metric_id,
//         name: metric.metric_name,
//       }));
//       setDropdownData(formattedData);
//       console.log("Métricas obtenidas para el dropdown de Measurement:", formattedData);
//     } catch (error) {
//       console.error("Error obteniendo métricas:", error);
//     }
//   };

//   const handleSelectChange = (e) => {
//     const selectedOption = dropdownData.find((option) => option.id === e.target.value);
//     setSelectedMetric(selectedOption);
//     console.log("Métrica seleccionada:", selectedOption);
//   };

//   const handleConfirm = () => {
//     if (selectedMetric) {
//       onSelect(selectedMetric); // Devolver la métrica seleccionada
//       console.log("Métrica seleccionada enviada:", selectedMetric);
//       onRequestClose(); // Cerrar el modal
//     }
//   };

//   return (
//     <Modal isOpen={isOpen} onRequestClose={onRequestClose} ariaHideApp={false}>
//       <h2>Selecciona una Métrica</h2>
//       <select onChange={handleSelectChange} value={selectedMetric ? selectedMetric.id : ""}>
//         <option value="" disabled>Seleccione una métrica</option>
//         {dropdownData.map((option) => (
//           <option key={option.id} value={option.id}>{option.name}</option>
//         ))}
//       </select>
//       <button onClick={onRequestClose} style={{ marginRight: '10px', backgroundColor: 'red', color: 'white' }}>Cancelar</button>
//       <button onClick={handleConfirm} style={{ backgroundColor: 'blue', color: 'white' }}>Confirmar</button>
//     </Modal>
//   );
// };

// export default WorkflowMeasurementModal;















import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

const WorkflowMeasurementModal = ({ isOpen, onRequestClose, onSelect, hostId }) => {
  const [dropdownData, setDropdownData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  // Función para obtener las métricas según el hostId
  const fetchMetricsData = async () => {
    try {
      const response = await fetch(`http://127.0.0.1:8000/device_metrics_for_host/${hostId}`);
      const data = await response.json();
      setDropdownData(data);
    } catch (error) {
      console.error("Error obteniendo las métricas:", error);
    }
  };

  useEffect(() => {
    if (isOpen && hostId) {
      fetchMetricsData();
    }
  }, [isOpen, hostId]);

  const handleSelectChange = (e) => {
    const selectedMetricId = e.target.value;
    const selectedOption = dropdownData.find(option => option.id === parseInt(selectedMetricId));
    setSelectedId(selectedMetricId);
    onSelect(selectedOption);
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} ariaHideApp={false} style={{
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      }
    }}>
      <h2>Selecciona una Métrica</h2>
      {dropdownData.length > 0 ? (
        <select onChange={handleSelectChange} value={selectedId || ''}>
          <option value="" disabled>Seleccione una métrica</option>
          {dropdownData.map(option => (
            <option key={option.id} value={option.id}>
              {option.visible_name || option.metric}
            </option>
          ))}
        </select>
      ) : (
        <p>No hay métricas disponibles para este dispositivo.</p>
      )}
      <div style={{ marginTop: '20px' }}>
        <button onClick={onRequestClose} style={{ padding: '10px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
          Cancelar
        </button>
      </div>
    </Modal>
  );
};

export default WorkflowMeasurementModal;
